import React, { useState } from 'react';
import { Box, Button, Typography, Input, Paper } from '@mui/material';
import {main_url,relatedModelMap,attachmentName} from  './basefile';

const FileUploader = ({obj_id, catog}) => {

  const [file, setFile] = useState(null);
  const token  = localStorage.getItem('authToken');
 
  //Document related_model - projects.Project, patients.Patient, options.Option, patients.PatientProjectExecution
  // alert(obj_id);
  
 const [metadata, setMetadata] = useState({
    name: attachmentName[catog] ?? 'unknown',
    description: 'NA',
    content_type: 'Image',
    related_model: relatedModelMap[catog] ?? 'unknown.Model',
    object_id: obj_id,
  });
 
  const handleChange = (e) => {
    setFile(e.target.files[0]);
  };
  
  
  const handleUpload = async () => {
    //alert(obj_id);
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    metadata.object_id = obj_id;

    const formData = new FormData();

    formData.append('file', file); // 'document' matches your Django view's field name
    formData.append('name', metadata.name);
    formData.append('description', metadata.description);
    formData.append('content_type', metadata.content_type);
    formData.append('related_model', metadata.related_model);
    formData.append('object_id', metadata.object_id);

    try {
       // http://13.201.185.64:8000/api/v1/documents/upload/
      const response = await fetch(`${main_url}/api/v1/documents/upload/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`, // only if using JWT or token auth
          // Do not manually set Content-Type, let the browser handle it
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const result = await response.json();
      alert("✅ File uploaded successfully!");
      console.log(result);
    } catch (error) {
      console.error("❌ Upload failed:", error.message);
      alert("Upload failed.");
    }
  };

  return (
    <Box
      component={Paper}
      elevation={2}
      sx={{
        padding: 4,
        maxWidth: 800,
       
        textAlign: 'left',
        borderRadius: 2,
        ml:0
      }}
    >
      <Typography variant="h5" gutterBottom>
        Attach Document
      </Typography>

      <Input
        type="file"
        onChange={handleChange}
        fullWidth
        disableUnderline
        sx={{
          marginBottom: 3,
          backgroundColor: '#f5f5f5',
          padding: 1,
          borderRadius: 1,

        }}
      />

      <Button  sx={{ display: 'flex', justifyContent: 'center', }}
        variant="contained"
        color="primary"
        onClick={handleUpload}
      >
        Upload
      </Button>
    </Box>
  );
};

export default FileUploader;
